import { useContext } from 'react';
import { Box } from '@mui/material';

import { RiskPanelGraph } from '../../../../portfolio-performance/components/cards/risk-panel-card/risk-panel-graph';
import { RiskContext } from '../../../../../providers/portfolio-performance/risk';
import { MetricKey } from '../../../../../providers/portfolio-performance/risk/risk.types';
import '../../../../portfolio-performance/components/cards/risk-panel-card/styles.scss';

// Same fixed layout as RiskPanelCard — PV full-width on top, then Delta|Theta,
// Gamma|Vega — reusing its RiskPanelGraph verbatim. The only difference is no
// RiskPanelFilters: token/range/BASE-QUOTE controls don't apply to a fixed,
// single-stratlet full-run greeks series (the range buttons wouldn't even
// filter it — they only reset chart zoom), so they're omitted rather than
// wired to something meaningless.
const LAYOUT: { key: MetricKey; label: string; fullWidth?: boolean; height: number }[] = [
  { key: 'PV', label: 'PV', fullWidth: true, height: 320 },
  { key: 'DELTA', label: 'Delta', height: 260 },
  { key: 'THETA', label: 'Theta', height: 260 },
  { key: 'GAMMA', label: 'Gamma', height: 260 },
  { key: 'VEGA', label: 'Vega', height: 260 },
];

export const BacktestRiskPanel = () => {
  const { metricsData, selectedToken, loadingMetrics, errorMetrics } = useContext(RiskContext);

  return (
    <div className="pp-graphs">
      <div className="pp-graphs-header">
        <span className="pp-risk-title">Risk</span>
      </div>

      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1.5 }}>
        {LAYOUT.map(({ key, label, fullWidth, height }) => {
          const series = (metricsData[key]?.data ?? []).map(([time, value]) => ({ time, value }));

          return (
            <Box key={key} sx={{ gridColumn: fullWidth ? '1 / -1' : undefined, height }}>
              <RiskPanelGraph
                metric={key}
                label={`${label} — ${selectedToken}`}
                series={series as never}
                loading={loadingMetrics[key] ?? false}
                error={errorMetrics[key] ?? false}
              />
            </Box>
          );
        })}
      </Box>
    </div>
  );
};
